import { httpClient } from '@/api/http-client'
import { AddressPayload, CompanyTaxRegime, ContactPayload } from '@/types'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

type SerproCNAE = {
  code: string
  description: string
  is_primary: boolean
}

export type ReadCompanySerproResult = {
  tax_id: string
  corporate_name: string
  trade_name: string | null
  incorporation_date: Date
  address: AddressPayload & { ibge_code: string }
  contacts: ContactPayload[]
  cnaes: SerproCNAE[]
  simple_tax_regime: Omit<CompanyTaxRegime, 'company_id' | 'id'>
}

type Params = {
  companyKey: string
  taxId: string
}

export const readCompanySerpro = async ({ companyKey, taxId }: Params) => {
  const response = await httpClient('accounting-dealer').get<ReadCompanySerproResult>(
    `/v3/company/${companyKey}/serpro`,
    { params: { tax_id: taxId } },
  )
  return response.data
}

export const useReadCompanySerpro = (
  { companyKey, taxId }: Params,
  options?: Partial<UseQueryOptions<ReadCompanySerproResult>>,
) => {
  return useQuery({
    queryKey: ['company-serpro', companyKey, taxId],
    queryFn: () => readCompanySerpro({ companyKey, taxId }),
    retry: false,
    ...options,
  })
}
